module.exports = __webpack_public_path__ + "img/Flag_of_Palau.03a68a73.svg";